//ApplicationEN
const lng = "en";
const info = {
  "Head": {
    lng,
    "Home": "Home",
    "Download": "Download",
    "Applications": "Research",
    "About": "About"
  },
  "Foot": {
    "location": "Nanjing Southeast University, Jiangsu Province",
    "record-number": "浙ICP备19018277号",
  },
  "about": {
    "Member-1-1":"Zhibin Li",
    "Member-1-2":"Ph.D. & Professor",
    "Member-1-3":"Southeast University",
    "Member-2-1":"Xinqiang Chen",
    "Member-2-2":" Ph.D. & Professor",
    "Member-2-3":"Shanghai Maritime University",
    "Member-3-1":"Qifan Wu",
    "Member-3-2":"Master",
    "Member-3-3":"Southeast University",
    "Member-4-1":"Changyan Fan",
    "Member-4-2":"Master",
    "Member-4-3":"Southeast University",
    "Member-5-1":"Ruyi Feng",
    "Member-5-2":"Ph.D.",
    "Member-5-3":"Southeast University",
    "Member-6-1":"Kequan Chen",
    "Member-6-2":"Ph.D.",
    "Member-6-3":"Southeast University",
    "Member-7-1":"Yaxu Li",
    "Member-7-2":"Master",
    "Member-7-3":"Southeast University",
    "Member-8-1":"Dongyu Tian",
    "Member-8-2":"Master",
    "Member-8-3":"Southeast University",
    "Member-9-1":"ShunChao Wang",
    "Member-9-2":"Ph.D.",
    "Member-9-3":"Southeast University",
    "Member-10-1":"Huihuang Zhu",
    "Member-10-2":"Master",
    "Member-10-3":"Southeast University",
    "TeamMainContributors": "Main Contributors",
    "TeamsMembers":"Team members",
    "TeamActivities":"Activity information",

    lng,
    //top-title
    "top-title": "About Our Team",
    "top-A": "The UTE team is composed of traffic sensing researchers from Southeast University. The team advocates openness, cooperation and sharing. Relevant scientific research activities, research progress and scientific information will be updated constantly.",
    //NEWS
    "NEWS": "NEWS",
    "N1-T": "The title of news",
    "N1-A": "An abstract of the news and events is shown here.", //这一部分是左边滚动新闻的标题和
    "N1": "· XXXXXXXX",
    "N2": "· XXXXXXXX",
    "N3": "· XXXXXXXX",
    "N4": "· XXXXXXXX",
    "N5": "· XXXXXXXX",
    "N6": "· XXXXXXXX",
    "N7": "· XXXXXXXX",
    //Team Member
    "TM1-1": "Dr. Zhibin Li",
    "TM1-2": "Personal homepage link",
    "TM1-3": "Zhibin Li received his Ph.D. degree from the School of Transportation at the Southeast University in China. He is now a Professor at Southeast University. From 2015 to 2016, he was a postdoctoral researcher in the Smart Transportation Applications and Research Laboratory at the University of Washington, United States.From 2010 to 2012, he was a visiting student in the University of California, Berkeley.He received China National Scholarship in 2012 and 2013, and won the Best Doctoral Dissertation Award by China Intelligent ransportation Systems Association. His research interests include ITS, big data, traffic safety, and traffic flow theory.",
    "TM2-1": "Xinqiang Chen",
    "TM2-2": "Xinqiang Chen received his Ph.D. degree (2018) in traffic information engineering and controlling at the Shanghai Maritime University in China. His research interests include traffic data analysis, transportation image processing, transportation video analysis, smart ship etc. ",
    "TM3-1": "Qifan Wu",
    "TM3-2": "Qifan Wu is studying in transportation engineering at Southeast University in China.He is now a research assistant in Professor Zhibin Li’s group at Southeast University. His research interests include transportation video analysis, intelligent transport system and so on.",
    "TM4-1": "Changyan Fan",
    "TM4-2": "Changyan Fan received his bachelor degree at Central South university. He is now a research assistant in Professor Zhibin Li’s group at Southeast University. His research interests include image processing, transportation video analysis and so on.",
    "TM5-1": "Ruyi Feng",
    "TM5-2": "Ruyi Feng has been studying at the School of Transportation, Southeast University since 2017. Her research interests mainly includes intelligent transportation, image processing, vehicle tracking, and trajectory extraction.",

    //Contact Us
    "CU-1": "Do you have any questions or suggestions?",
    "CU-1-1": "Contact us here!",
    "CU-2": "Please leave an Email in order for a reply. (E-mail address will be kept secret.)",
  },
  "Applications":
  {//这个是"Applications"页面的一些内容
    "TT1":"In recent years, research based on vehicle trajectories has driven continuous progress in traffic flow theory, behavioral modeling, driving pattern analysis, and safety diagnostics. This has fostered a deeper understanding of traffic phenomena and their underlying mechanisms. This database has spawned numerous related studies, and this page showcases and introduces these results. We welcome the attention of researchers.",
    "TT2":"We thank all researchers who have used our data over the past three years. We will continue to maintain open channels of communication and welcome any inquiries.",

    "DATA-SET": "DATA SET",
    lng,
    "top-title": "Scientific Research",
    //top-research
    "top-res-title": "RESEARCH",
    "top-res-1": "Through diverse data, research in various directions like research on ",
    "top-res-2": "traffic flow, traffic control",//变色
    "top-res-3": ", and ",
    "top-res-4": "traffic safety ",//变色
    "top-res-5": "can be supported.",
    //top-project
    "top-pro-title": "PROJECT",
    "top-pro-1": "Through rich data acquisition methods, various projects like ",
    "top-pro-2": "ramp design ", //变色
    "top-pro-3": "and ",
    "top-pro-4": "drop-off platform design ", //变色
    "top-pro-5": "are supported.",
    //top-data
    "top-data-1": "95",
    "top-data-2": "+",
    "top-data-3": "%",

    //data-res
    "data-res-title": "RESEARCH",
    "data-res-1": "Traffic flow, Traffic control, and Traffic Safty can be supported.",
    "data-res-more": "MORE",
    //data-pro
    "data-pro-title": "PROJECT",
    "data-pro-1": "Ramp control design, Drop-off platform design can be supported.",
    "data-pro-more": "MORE",

    //Derived Research
    "D-R-title": "Derived Research",
    //DR1
    "DR1-T": "Trajectories and Traffic Parameters' Extraction", //变色
    "DR1-A": "Vehicle Trajectory balbala (TITLE) Published in XXX,Author: Zhibin Li, XXX,Key words: UAV, trajectory, image processing, xxx",
    //DR2
    "DR2-T": "Trajectories and Traffic Parameters' Extraction", //变色
    "DR2-A": "Vehicle Trajectory balbala (TITLE) Published in XXX Author: Zhibin Li, XXX Key words: UAV, trajectory, image processing, xxx",

    //DR2
    "DR2-T": "Trajectories and Traffic Parameters' Extraction", //变色
    "DR2-A": "Vehicle Trajectory balbala (TITLE)Published in XXXAuthor: Zhibin Li, XXX Key words: UAV, trajectory, image processing, xxx",

    //Derived Project
    "D-P-title": "Derived Project",
    //DP1
    "DP1-T": "Trajectories and Traffic Parameters' Extraction",
    "DP1-A": "Trajactory extraction from Surveillance videos based on CNN",
    //DP2
    "DP2-T": "Trajectories and Traffic Parameters' Extraction",
    "DP2-A": "Hige precision Trajactory extraction from UAV videos based on CNN",
    //DP3
    "DP3-T": "Trajectories and Traffic Parameters' Extraction",
    "DP3-A": "Trajactory extraction from Surveillance videos based on CNN",

    //Product materialization
    "P-M-title": "Product materialization",
    "P-M-1": "XXX detector",
    "P-M-2": "XXX detector",
    "P-M-3": "XXX detector",
    "P-M-4": "XXX detector",
    "P-M-5": "XXX detector",
    "P-M-6": "XXX detector",
  },
  "home":
  {//这个是"Applications"页面的一些内容
    //top-title
    "Our-data": " Our data contains and applicable research",
    "Out-data-text1": " UAVs equipped with 4K cameras are used to record traffic, from which high-resolution trajectories are extracted. We optimized algorithms for vehicle localization, class and length estimation, and assembled them into a fully automatic video-based trajectory-extraction pipeline. The pipeline handles UAV multi-dimensional ego-motion, small target detection, track jitter,  fracture trajectories splicing,  and dynamic road coordinate transformation.",
    "label1-1": "Multi-dimensional Motion",
    "label1-2": "Small Target Detection",
    "label1-3": "Fracture Track Splicing",
    "label1-4": "Overcome Tracking Jitter",
    "label1-5": "Road Coordinate Transformation",
    "Out-data-text2": "Each trajectory in UTE dataset provides vehicle ID, localization x-y, lane index, length, width, speed, gap time, gap distance and acceleration. The time resolution is 10 Hz, and the spatial resolution is 0.01 meter.",
    "label2-1": "Vehicle ID",
    "label2-2": "Vehicle Position",
    "label2-3": "Lane ID",
    "label2-4": "Vehicle Size",
    "label2-5": "Speed",
    "label2-6": "Time Headway",
    "label2-7": "Space Headway",
    "label2-8": "Acceleration and Deceleration",
    "label2-9": "Time Accuracy",
    "label2-10": "Position Accuracy",

    "Out-data-text3": "The team took aerial photographs of multiple road traffic flows, ranging in height from 30 meters to 250 meters. The test results show that the target number detection accuracy of the algorithm is about 95-98%, and the vehicle position accuracy is about 95-99%. The team manually corrected and verified a small number of vehicle position deviations to ensure 100% vehicle detection and tracking in the open trajectory data set.",
    "label3-1": "Height Range",
    "label3-2": "Accuracy Range",
    "label3-3": "Open Access",

    "Out-data-text4": "The team will gradually enrich the road sections covered by the trajectory data (straight, interweaving, merging, diversion, lane changes, construction sections, etc.), traffic status (free flow, congested flow, synchronized flow, state transition process, etc.), traffic scenes (maneuvering) Traffic flow, motor vehicle-non-motor vehicle mixed traffic flow, etc.) and meteorological conditions. These data can be used for research on traffic flow theory modeling, traffic flow characteristics analysis, traffic operation evaluation, driving behavior analysis, and traffic conflict discrimination.",

    "label4-1-1": "Straight",
    "label4-1-2": "Interweave",
    "label4-1-3": "confluence",
    "label4-1-4": "Diversion",
    "label4-1-5": "Lane change",
    "label4-1-6": "Construction section",


    "label4-2-1": "Free flow",
    "label4-2-2": "Congested flow",
    "label4-2-3": "Synchronous stream",
    "label4-2-4": "State transition process",

    "label4-3-1": "Motor vehicle flow",
    "label4-3-2": "Motor vehicle and non-motor vehicle mixed flow",

    "top-title-1": "E",
    "top-title-2": "xtensive Site ",//变色
    "top-title-3": "Different ",
    "top-title-4": "V",//变色
    "top-title-5": "isual",
    "top-title-6": "Diverse",
    "top-title-7": "D",//变色
    "top-title-8": "ata",
    //top-type
    "top-type-1": "UAV videos",
    "top-type-2": "Surveillance videos",
    "top-type-3": "Other videos",
    //top-data
    "top-data-1": "10",
    "top-data-2": "+",
    "top-data-3": "of Sites",
    "top-data-4": "95",
    "top-data-5": "+",
    "top-data-6": "%",
    "top-data-7": "Accuracy",
    "top-data-8": "Thousands",
    "top-data-9": "Trajectory & Data",
    //top-paragraph
    "top-paragraph-1": "Vehicle trajectory data captures both macroscopic and microscopic traffic flow information, enabling data-driven explanations of traffic phenomena and problems. NGSIM trajectories suffer from systematic positioning errors that remain hard to correct. The dataset also spans limited road-segment lengths, time ranges, road environments, traffic states and vehicle mixes, and has not been substantially extended since release. Traffic environment in China is markedly more complex, and its control strategies and driving habits differ substantially from others. Consequently, the shortage of high-resolution, multi-scenario traffic-flow datasets continues to impede transportation research. ",
    "top-paragraph-2": "In recent years, the emerged UAV technology has brought new strategies for trajectory data collection. UAVs give flexible, rapidly-deployable, bird‘s-eye-view recording. It can collect traffic videos across a variety of road environments and scenarios. In addition, advances in computer vision technology have also provided technical support for extracting high-precision vehicle trajectories from aerial videos. These data can be used for research such as traffic flow modeling, traffic status assessment, driving behavior analysis, and traffic conflict identification. ",
    //top-button
    "top-button": "Get more here",

    //Production & Application
    "P-A-title-1": "Production",
    "P-A-title-2": " & ", //变色
    "P-A-title-3": "Application",

    //Team Member
    "T-M-title": "Team Member", //蓝色
    "T-M-1": "This team is led by Professor ",
    "T-M-2": "Zhibin Li", //加粗
    "T-M-3": ", who mainly studies traffic data acquisition and information interaction based on CV. ",
    "T-M-4": "By using the acquired data, the team members also did extended research. Click below for more details. ",
    "T-M-button": "Get more details",

    //Data Download
    "D-D-title": "Data Download", //蓝色
    "D-D-1": "At ",
    "D-D-2": "extensive sites", //加粗
    "D-D-3": ", videos and traffic flow data extracted from ",
    "D-D-4": "diverse perspectives ",//加粗
    "D-D-5": "are available at this station. ",
    "D-D-6": "Click below for more details and ",
    "D-D-7": "data download. ", //加粗
    "D-D-button": "Get more details",

    //Contact Us
    "C-U-title": "Team Member", //蓝色
    "C-U-1": "If you have any questions and suggestions, or need to customize personalized data, you can contact us via message or email.",
    "C-U-button": "Get more details",
  },
  "download": {
    "top-data-4": "Accuracy",
    "top-data-5": "10",
    "top-data-6": "+",
    "top-data-7": "Sites",
    "top-data-8": "Thousands",
    "top-data-9": "Trajectory",
    "top-data-10": "Trajectory & Data",
    "top-data-11": "4",
    "top-data-12": "+",
    "top-data-13": "Devices",
    "click jump": "Click to jump",
    "top-title-1": "Data Download",
    "top-title-2": "The data available for download on this website includes a video file with references, raw trajectory data, and a preview of the road geometry. Each trajectory in the UTE dataset provides vehicle ID, x-y position, lane index, length, width, speed, gap time, gap distance, and acceleration. Temporal resolution is 10 Hz, and spatial resolution is 0.01 meters.",
    "top-title-3": "The vehicle trajectory database includes vehicle number, position coordinate, lane number, vehicle length, vehicle width, driving speed, time headway, space headway, acceleration and deceleration and other parameters, with time accuracy of 0.1 second and position accuracy of 0.1 meter.",
    "DI_text": "An overview of the currently published data is provided below. By using our data, you agree to our Data Usage Agreement.",
    //Data Index
    "D-I-title": "Data Information ",
    "D-I-1": "UAV Data", //变色
    "D-I-2": "Surveillance Data",
    "D-I-3": "Stay tuned",
    "D-I-4": "Stay tuned",
    //Data based on UAV
    "D-UAV-title": "Data based on UAV",
    //Data based on Surveillance
    "D-Sur-title": "Data based on Surveillance"
  },"post":{
    "desc": "Ascending by time",
    "asc": "Descending by time",
    "1":"Team Activities",
    "2":"Derived Research",
    "3":"Derived Project",
  }
}
export default info;
